import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import getGetDocumentPendingDownload from "../../DependencyInjection/getDocumentPendingDownload";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";
import DocumentDownload from "../../Entity/DocumentDownload";

const eventDispatcher = getEventDispatcher();

const LoadPendingDownloadListener: EventHandler<string> = async (event: IpcMainInvokeEvent, content: string): Promise<void> => {
    const documentDownloads: DocumentDownload[] = getGetDocumentPendingDownload().get(content);
    for (const documentDownload of documentDownloads) {
        await eventDispatcher.dispatch('AddDownloadAction', documentDownload);
    }

    await eventDispatcher.dispatch('AddCurrentDownloadAction');
}

export default LoadPendingDownloadListener;